import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as Common from '_common';
import * as React from 'react';
export function StateFrames() {
    var frameRegister = Common.useFrameRegister();
    var spaContext = Common.useSpaContext();
    React.useEffect(function () {
        var _a;
        if (frameRegister && spaContext) {
            var processes = (_a = spaContext.process) !== null && _a !== void 0 ? _a : {};
            for (var _i = 0, _b = Object.keys(processes); _i < _b.length; _i++) {
                var process_1 = _b[_i];
                var processInfo = processes[process_1];
                var existingFrame = frameRegister.frame(process_1);
                if (processInfo && processInfo !== 'null') {
                    if (!existingFrame) {
                        var frame = {
                            id: process_1,
                            title: processInfo.name || "Process",
                            component: { type: "Process", properties: { id: process_1 } },
                        };
                        frameRegister.register(frame);
                    }
                }
                else {
                    if (existingFrame) {
                        frameRegister.remove(process_1);
                    }
                }
            }
        }
    }, [frameRegister, spaContext]);
    return _jsx(_Fragment, {});
}
